// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"bcddcf4ce17e8a2d","5437":"af6cdd43ed5f82c1"}[chunkId] + ".css";
};